import React from 'react';

const ButtonLoaderSvg = () => {
    return (
        <svg
            className="button-loader-svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                r="20"
                cx="25"
                cy="25"
                stroke="currentColor"
                strokeWidth="8"
                strokeLinecap="round"
                fill="transparent"
                strokeDasharray="125.6px"
            ></circle>
        </svg>
    );
};

export default ButtonLoaderSvg;
